import { useApiMutation } from "./use-api-mutation";

export interface DuplicateShopSettingsDto {
  targetShopId: string;
  carriers?: boolean;
  /** `replace` (default) deletes the target's carriers first, `append` keeps them. */
  carriersMode?: "replace" | "append";
  /** In `append` mode, for carriers whose code the target already has.
   * Unset: refused with 409 `duplicate-settings-carrier-code-conflicts`. */
  carrierCodeConflicts?: "skip" | "replace";
  rules?: boolean;
  preferences?: boolean;
  users?: boolean;
  exchange?: boolean;
  discount?: boolean;
  reasons?: boolean;
  disapprovalReasons?: boolean;
  integrations?: boolean;
  returnToStore?: boolean;
}

export default function useDuplicateShopSettings(shopId: string) {
  return useApiMutation("post", "/shops/{shopId}/duplicate-settings" as never, {
    // The dialog reports the outcome itself, with the reason of a refusal.
    notify: false,
    mapVariables: (requestBody: DuplicateShopSettingsDto) => ({
      params: { path: { shopId } },
      body: requestBody,
    }),
  });
}
